export const theme = {
  colors: {
    primary50: '#f4f3ff',
    primary100: '#ebe9fe',
    primary200: '#d9d6fe',
    primary300: '#bdb4fe',
    primary400: '#9b8afb',
    primary500: '#7a5af8',
    primary600: '#6938ef',
    primary700: '#5925dc',
    primary800: '#4a1fb8',
    primary900: '#3e1c96',
    subBlue50: '#eff7ff',
    subBlue100: '#d6eaff',
    subBlue200: '#b2d7ff',
    subBlue300: '#81beff',
    subBlue400: '#469fff',
    subBlue500: '#0069ff',
    subBlue600: '#0063cf',
    subBlue700: '#004ea3',
    subBlue800: '#003c7e',
    subBlue900: '#002c5c',
    grayScale0: '#ffffff',
    grayScale100: '#f5f5f5',
    grayScale200: '#ededed',
    grayScale300: '#e9e9e9',
    grayScale400: '#dddddd',
    grayScale500: '#cccccc',
    grayScale600: '#999999',
    grayScale700: '#666666',
    grayScale800: '#545454',
    grayScale900: '#333333',
    error50: '#fff1f2',
    error100: '#ffe4e6',
    error200: '#fecdd3',
    error300: '#fda4af',
    error400: '#fb7185',
    error500: '#f43f5e',
    error600: '#e11d48',
    error700: '#be123c',
    error800: '#9f1239',
    error900: '#881337',
    warning50: '#fffbeb',
    warning100: '#fef3c7',
    warning200: '#fde68a',
    warning300: '#fcd34d',
    warning400: '#fbbf24',
    warning500: '#f59e0b',
    warning600: '#d97706',
    warning700: '#b45309',
    warning800: '#92400e',
    warning900: '#78350f',
    success50: '#ecfdf5',
    success100: '#d1fae5',
    success200: '#a7f3d0',
    success300: '#6ee7b7',
    success400: '#34d399',
    success500: '#10b981',
    success600: '#059669',
    success700: '#047857',
    success800: '#065f46',
    success900: '#064e3b',
    supportBlue: '#0b3f98',
    supportPink: '#fe5493',
    supportPurple: '#9747ff',
  },
  typography: {
    titleH1: {
      fontFamily: "'Pretendard', sans-serif",
      fontSize: '48px',
      fontWeight: 900,
      lineHeight: '72px',
    },
    titleH2: {
      fontFamily: "'Pretendard', sans-serif",
      fontSize: '36px',
      fontWeight: 900,
      lineHeight: '54px',
    },
  },

  checkbox: {
    spacing: {
      small: '8px',
      medium: '16px',
      large: '24px',
    },

    size: {
      small: '16px',
      medium: '24px',
      large: '32px',
    },
  },
};
